import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GridSizeRules } from '../../dashboard.types';

export const ORDER_QUEUE_RULES: GridSizeRules = {
  minCols: 4, maxCols: 12,
  minRows: 4, maxRows: 16
};

@Component({
  selector: 'rny-order-queue-widget',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './order-queue.widget.html',
  styleUrls: ['./order-queue.widget.scss']
})

export class OrderQueueWidget {


  /** KPI counts (bind from parent or load internally once wired to API) */
  @Input() pending = 0;
  @Input() ready = 0;
  @Input() blocked = 0;


  openList() {
    // TODO: route to your finalize-POs screen or open popup
    console.log('Open Finalize POs list');
  }
}
